<template>
  <div>
    <Card
      class="bg-light-grey rounded-xl p-5 flex flex-col justify-between h-44"
    >
      <template #header
        ><div class="flex justify-between">
          <p class="text-primary-900 text-xl">
            {{ $t("home.status") }}
          </p>
          <Button
            class="bg-white hover:!bg-primary-900 rounded-full"
            icon="mdi-help-circle-outline"
            @click="goToStatusReport()"
            rounded
          >
            <v-icon class="text-primary-500 text-3xl hover:!text-white">{{
              "mdi-eye-outline"
            }}</v-icon></Button
          >
        </div></template
      >
      <template #content
        ><div class="flex justify-center mx-4 grid grid-cols-3">
          <Button
            :class="[
              'flex h-12 2xl:p-8 p-4 rounded-s-xl text-sm',
              {
                'bg-green-600 text-white': userStatus == 1 && isConnected,
                'bg-red-500 text-white enabled:hover:bg-green-600 border-solid border border-primary-900':
                  userStatus == 1 && !isConnected,
                'text-red enabled:hover:bg-green-600 border-solid border border-primary-900':
                  userStatus != 1,
              },
            ]"
            @click="setStatus(1, { period: null, reason: null })"
            :loading="statusLoading[1]"
          >
            <v-icon class="mt-0.5">{{
              userStatus == 1 && isConnected
                ? "mdi-account-check-outline"
                : "mdi-account-cancel-outline"
            }}</v-icon>
            <p>
              {{
                userStatus == 1 && isConnected
                  ? $t("home.agent_status.online_status")
                  : $t("home.agent_status.offline_status")
              }}
            </p>
          </Button>

          <Button
            class="flex h-12 2xl:p-8 p-4 text-sm"
            :class="{
              'bg-yellow-100 text-black': userStatus == 2,
              'hover:bg-yellow-300 text-black  border-solid border border-primary-900':
                userStatus != 2,
            }"
            @click="restAgent('open')"
            :loading="statusLoading[2]"
          >
            <v-icon class="mt-0.5">{{ "mdi-coffee-outline" }}</v-icon>
            <p>{{ $t("home.agent_status.rest_status") }}</p>
          </Button>
          <Menu
            class="!bg-gray-100 !border-none"
            :ref="'periodsMenu'"
            :model="['open', ...periods]"
            :popup="true"
            :id="'periodsMenu'"
            :pt="{
              root: {
                dir: 'ltr',
              },
            }"
          >
            <template #item="{ item }">
              <div
                class="flex items-center gap-2 min-w-[200px] hover:!bg-grey-100 cursor-pointer text-black"
                @click="restAgent(item)"
              >
                <p>
                  {{
                    item == "open"
                      ? $t("home.agent_status.open_status")
                      : currentLocal == "ar"
                      ? $t(
                          getArabicPluralKey("plural.minute", Number(item)),
                          Number(item)
                        )
                      : $t("home.agent_status.minutes", Number(item))
                  }}
                </p>
              </div>
            </template>
          </Menu>

          <Button
            :class="[
              'flex h-12 rounded-e-xl 2xl:p-8 p-4 text-sm',
              {
                'bg-red-500 text-white': userStatus == 3,
                'enabled:hover:bg-red-400 !text-black  border-solid border border-primary-900':
                  userStatus != 3,
              },
            ]"
            @click="toggleNotReadyMenu()"
          >
            <v-icon class="mt-0.5">{{ "mdi-account-off-outline" }}</v-icon>
            <p>
              {{ $t("home.agent_status.not_ready_status") }}
            </p>
          </Button>
          <Menu
            class="!bg-gray-100 !border-none"
            :ref="'notReadyMenu'"
            :model="notReadyReasons"
            :popup="true"
            :id="'notReadyMenu'"
            :pt="{
              root: {
                dir: 'ltr',
              },
            }"
          >
            <template #item="{ item }">
              <div
                class="flex items-center gap-2 min-w-[200px] hover:!bg-grey-100 cursor-pointer text-black"
                @click="setStatus(3, { period: null, reason: item })"
              >
                <p>
                  {{
                    $t(
                      "home.agent_status.not_ready_status_reason." +
                        item?.reason
                    ).includes("home.")
                      ? item?.reason
                      : $t(
                          "home.agent_status.not_ready_status_reason." +
                            item?.reason
                        )
                  }}
                </p>
              </div>
            </template>
          </Menu>
        </div></template
      >
    </Card>
  </div>
</template>

<script>
import { Card, Button, Menu } from "primevue";
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  components: {
    Card,
    Button,
    Menu,
  },
  data() {
    return {
      statusToggle: 1,
      statusLoading: [],
      userStatus: 0,
      showRestDialog: false,
      selectedPeriod: this.$t("reports.filters.hours"),
      notReadyReasons: [],
    };
  },
  methods: {
    async restAgent(period) {
      this.selectedPeriod = period == "open" ? null : period;
      await this.setStatus(2, { period: this.selectedPeriod });
    },
    async setStatus(statusRequested, { period = null, reason = null }) {
      if (
        statusRequested == this.userStatus ||
        ![1, 2, 3, 4].includes(statusRequested)
      ) {
        return;
      }
      this.statusLoading[statusRequested] = true;
      const request = {
        status: statusRequested,
        user: this.uname,
        skills: this.skills,
      };
      if (period) {
        request.period = period;
      }
      if (reason) {
        request.reason = reason.id;
      }
      try {
        const resp = await this.setUserStatus(request);
        this.statusLoading[statusRequested] = false;
        if (resp.success) {
          this.userStatus = statusRequested;
        } else {
          Swal.fire({
            icon: "error",
            text: resp.message,
          });
          this.statusToggle = this.userStatus;
        }
      } catch (err) {
        this.statusLoading[statusRequested] = false;
        this.statusToggle = this.userStatus;
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        Swal.fire({
          icon: "error",
          text: message,
        });
      }
    },
    async initStatus() {
      this.userStatus = this.status;
      this.statusToggle = this.userStatus;
      await this.GetRestPeriods();
      await this.GetStatusReasons();
    },
    goToStatusReport() {
      this.$router.push({
        name: "agent-status-report",
      });
    },
    togglePeriodsMenu(event) {
      this.$refs.periodsMenu.toggle(event);
    },
    toggleNotReadyMenu() {
      this.$refs.notReadyMenu.toggle(event);
    },
    ...mapActions([
      "setUserStatus",
      "SetMessageDialog",
      "GetRestPeriods",
      "GetStatusReasons",
    ]),
  },
  computed: {
    ...mapGetters([
      "domain",
      "status",
      "periods",
      "skills",
      "uname",
      "isConnected",
      "statusReasons",
    ]),
    enableStatus() {
      if (this.userStatus == 4) {
        return false;
      }
      return true;
    },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  watch: {
    domain() {
      this.initStatus();
    },

    status(newStatus) {
      this.statusToggle = newStatus;
      this.userStatus = newStatus;
    },
    statusReasons(newReasons) {
      this.notReadyReasons = newReasons.filter((reason) => reason.status == 3);
      console.log(this.notReadyReasons);
    },
  },
  mounted() {
    if (this.domain) {
      this.initStatus();
    }
  },
};
</script>
